<template>
  <v-card class="text-center" flat style="height: 100%;">
    <v-card-text class="py-16">
      <h3 class="text--primary py-7">
        Vaša objednávka bola potvrdená.
      </h3>
      <p>O jej ďalšom stave Vás budeme informovať prostredníctvom emailu.</p>
      <v-icon color="#007520" x-large>mdi-check-circle</v-icon>
      <h3 class="my-5">
        Kód Vašej objednávky je:
        <span class="accent--text text--lighten-2">{{ getOrderCode }}</span>
      </h3>
      <p>
        Pomocou tohto kódu si ju môžte zobraziť v sekcii
        <router-link to="/userOrders"
          ><a class="accent--text text--lighten-2"
            >Moje objednávky</a
          ></router-link
        >
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OrderCompleted",
  data: () => ({
    orderCode: ""
  }),
  methods: {},
  computed: {
    getOrderCode() {
      return localStorage.getItem("code");
    }
  }
};
</script>
